import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { SfhSecurityService } from '@sasser/sfh-shared-security';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

  constructor(private sfhSecurity: SfhSecurityService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.sfhSecurity.isAuthenticated()) {
      return true;
    }

    alert('Access Denied');

    this.router.navigate(['/starterview']);
    return false;
  }
}